import React from 'react'
import { Gravatar } from 'src/components/Gravatar'
import { FlexAlign, FlexRow } from 'src/components/Reusable/Flex'

type UserSelectLabelProps = {
  email: string
  name?: string
}

export const UserSelectLabel = ({
  email,
  name,
}: UserSelectLabelProps): JSX.Element => (
  <FlexRow gap={8} align={FlexAlign.FLEX_START} justify={FlexAlign.FLEX_START}>
    <Gravatar email={email} />
    {name || email}
  </FlexRow>
)
